var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderLogoTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 18,
    viewBox: "0 0 56 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4417 2.96119H7.87178V17.003H4.54601V2.96119H0V0H12.4417V2.96119ZM27.546 0V11.1761C27.546 13.0229 26.9161 14.4796 25.656 15.5463C24.4118 16.6129 22.8726 17.1463 21.0382 17.1463C19.2038 17.1463 17.6566 16.6129 16.3965 15.5463C15.1523 14.4796 14.5302 13.0229 14.5302 11.1761V0H17.856V11.0567C17.856 12.1075 18.1431 12.8955 18.7174 13.4209C19.3075 13.9304 20.0812 14.1851 21.0382 14.1851C21.9953 14.1851 22.7689 13.9304 23.3591 13.4209C23.9493 12.8955 24.2444 12.1075 24.2444 11.0567V0H27.546ZM42.2363 2.96119H36.2308C35.5288 2.96119 35.0344 3.0965 34.7473 3.36716C34.476 3.63783 34.3406 4.10746 34.3406 4.77612V7.1403H40.5854L40.3461 10.1015H34.3406V17.003H31.0148V3.46269C31.0148 2.20499 31.2861 1.31343 31.8283 0.788059C32.3867 0.262686 33.3357 0 34.6755 0H42.2363V2.96119ZM56.349 2.96119H50.3435C49.6415 2.96119 49.1472 3.0965 48.8601 3.36716C48.5887 3.63783 48.4533 4.10746 48.4533 4.77612V7.1403H54.6981L54.4588 10.1015H48.4533V17.003H45.1275V3.46269C45.1275 2.20499 45.3989 1.31343 45.941 0.788059C46.4995 0.262686 47.4484 0 48.7883 0H56.349V2.96119Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogoTitle);
export default __webpack_public_path__ + "static/media/HeaderLogoTitle.cac5b3ce77f0d796ef91d6b7913dbbbe.svg";
export { ForwardRef as ReactComponent };